import { Resources } from 'src/shared/types';
import { ProductKey } from 'src/shared/types/engine/products';
import { ProductAccess } from 'src/shared/types/productLicensing';
import useFeature from './useFeature';
import { useProductAccess } from './useProductLicensing';

/** How much of Species Insights the current user may see on the current site. The site has results when it has the Species Insights map resource. */
const useSpeciesInsightsAccess = (): ProductAccess => {
    const { hasResource } = useFeature();

    return useProductAccess(ProductKey.SPECIES_INSIGHTS, hasResource({ resource: Resources.SPECIES_INSIGHTS_MAP }));
};

export default useSpeciesInsightsAccess;
